import styled from '@emotion/styled';
import LinkIcon from '@/public/icons/record/link.svg';

const Container = styled.button<{ isFocused?: boolean }>`
  width: 100%;
  font-size: 14px;
  padding: 4px;
  border-radius: 4px;
  background-color: ${({ isFocused }) =>
    isFocused ? '#e8e8e8' : 'transparent'};
  :hover {
    background-color: ${({ isFocused }) => (isFocused ? '#e8e8e8' : 'var(--dk-bg-muted, #f3f5f6)')};
  }
  font-weight: 400;
  line-height: 20px;
`;

const StyledLinkButton = styled(LinkIcon)`
  margin-left: 8px;
  color: var(--dk-text-secondary, #888d96);
  :hover {
    color: var(--dk-text, black);
  }
`;

const StyledLabel = styled.div<{ isApproval?: boolean }>`
  color: ${({ isApproval }) => (isApproval ? 'var(--dk-accent, #06c)' : '#C77AC4')};
  font-size: 12px;
  font-weight: 700;
  line-height: 16px; /* 133.333% */
  border-radius: 4px;
  background: ${({ isApproval }) =>
    isApproval
      ? 'linear-gradient(0deg, rgba(0, 102, 204, 0.08) 0%, rgba(0, 102, 204, 0.08) 100%), #FFF'
      : 'linear-gradient(0deg, rgba(199, 122, 196, 0.08) 0%, rgba(199, 122, 196, 0.08) 100%), #FFF'};
  border: ${({ isApproval }) =>
    isApproval ? '1px solid #06C' : '1px solid #C77AC4'};
  height: 26px;
  display: flex;
  min-width: 50px;
  justify-content: center;
  align-items: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

const TitleText = styled.div`
  margin-left: 8px;
  flex-grow: 1;
  text-align: left;
  word-break: break-word;
`;

const MobileTitleText = styled.div`
  display: -webkit-box; /* flexbox처럼 동작 */
  -webkit-line-clamp: 2; /* 보여줄 줄 수 */
  -webkit-box-orient: vertical; /* 세로 방향 박스 */
  overflow: hidden; /* 넘치는 텍스트 숨김 */
  text-overflow: ellipsis; /* ... 처리 */
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  flex-grow: 1;
`;

const InfoWrapper = styled.div`
  display: flex;
  justify-content: right;
  margin-left: 8px;
  word-break: keep-all;
`;

const CreatorText = styled.div`
  color: var(--dk-text-secondary, #888d96);
`;

const Divider = styled.div`
  width: 1px;
  height: 12px;
  background-color: var(--dk-bg-strong, #e7e9ec);
  margin-left: 10px;
`;

const DateText = styled.div`
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 82px;
  color: var(--dk-text-secondary, #888d96);
`;

const MobileLayout = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export {
  Container,
  StyledLinkButton,
  StyledLabel,
  ContentWrapper,
  TitleText,
  InfoWrapper,
  CreatorText,
  Divider,
  DateText,
  MobileTitleText,
  MobileLayout,
};
